<template>
  <div class="com-list-content carousel-wrapper">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <el-row>
        <el-col :span="12">
          <el-form-item label="视频：" prop="pic1">
            <el-upload class="uploader-form" action="/singleMuseum/attach/upload" accept="video/*" :disabled="!editFlag" :data="configData" :show-file-list="false" :on-progress="uploadVideoProcess" :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload">

              <video v-if="videoUrl != '' && !videoFlag" v-bind:src="videoUrl" class="w-100" controls="controls">
                您的浏览器不支持视频播放
              </video>

              <div class="tip" v-else-if="videoUrl == '' && !videoFlag">
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传视频</div>
              </div>

              <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent" style="margin-top: 7px"></el-progress>
            </el-upload>
            <div class="tip-img" style="left: 0">建议视频大小：375 * 325</div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="视频封面：" prop="pic2">
            <div class="uploader-form flex-center" @click="uploadPicture">
              <img v-if="form.pic2" :src="form.pic2" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <!-- <div class="el-upload__text">上传轮播图封面</div> -->
            </div>
            <div class="tip-img" style="left: 0">建议图片大小：375 * 325</div>
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <div class="btn">
      <el-button type="primary" v-if="editFlag" :loading="loadingSave" @click="submit">确定</el-button>
      <el-button type="primary" v-else @click="editFlag = true">编辑</el-button>

    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </div>
</template>

<script>
import CropperImage from "@cmp/cropper";
export default {
  components: { CropperImage },
  data() {
    const validatePic1 = (rule, value, callback) => {
      if (!this.form.pic1) {
        callback(new Error('视频不能为空'))
      } else {
        callback()
      }
    }

    const validatePic2 = (rule, value, callback) => {
      if (!this.form.pic2) {
        callback(new Error('视频封面不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        pic1: '',
        pic2: '',
      },
      imgUrl: '',
      rules: {
        pic1: [{ required: true, validator: validatePic1, trigger: 'change' }],
        pic2: [{ required: true, validator: validatePic2, trigger: 'change' }]
      },
      configData: {
        tableName: 'volunteer'
      },
      videoFlag: false,
      videoUrl: "",
      videoUploadPercent: 0,
      imgUrl: "",
      editFlag: true,
      loadingSave: false,
      //裁切图片参数
      cropperModel: false,
    }
  },
  methods: {
    handleUploadSuccess(result) {
      this.form.pic2 = result.attPath
      this.imgUrl = ""
      this.cropperModel = false
    },

    getData() {
      this.$api.applet.getPics({
        type: 6
      }).then(res => {
        if (res.success) {
          if (res.result) {
            this.form = res.result
            this.videoUrl = this.form.pic1
            this.editFlag = false
          }
        }
      })
    },

    beforeVideoUpload(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1     //控制格式
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
    },

    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        this.videoUrl = res.result.attPath
        this.form.pic1 = res.result.attPath
      } else {
        this.$message.error(res.message)
      }
    },

    //进度条
    uploadVideoProcess(file, fileList) {    
      this.videoFlag = true // 显示进度条
      this.videoUploadPercent = parseInt(file.percent)
    },

    //封面设置
    uploadPicture() {
      if (!this.editFlag) {
        return
      }
      this.imgUrl = this.form.pic2

      let option = {
        cropWidth: "375", cropHeight: "325", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    submit() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = 'addPics'
          if (this.form.id) {
            url = 'updatePics'
          }
          this.$api.applet[url]({
            ...this.form,
            type: 6
          }).then(res => {
            this.loadingSave = false

            if (res.success) {
              if (this.form.id) {
                this.$message.success('修改成功')
              } else {
                this.$message.success('新增成功')
              }
              this.getData()
            } else {
              this.$message.warning(res.message)
            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.carousel-wrapper {
  height: 100%;
  margin-top: 0;
  .uploader-form {
    width: 400px;
    height: 250px;

    border: 1px dashed #8c939d;
    /deep/ .el-upload {
      width: 100%;
      height: 100%;
      display: flex;
      cursor: pointer;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      video {
        width: 375px;
        height: 215px;
        object-fit: cover;
      }
    }
    img {
      width: 375px;
      height: 215px;
      object-fit: cover;
    }
    i {
      font-size: 34px;
    }
  }

  .btn {
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
}
</style>